import React, { useCallback, useMemo } from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { DefaultDialogProps } from 'src/Libs/modals'
import { IdlePeriodActivateForm, IdlePeriodDeactivateForm } from 'src/Libs/smart-charge/components/forms'
import { IdlePeriodStatusProcessingType } from 'src/Libs/smart-charge/types'
import { Formik } from 'formik'
import { PeriodFormInputType } from 'src/Libs/types'

export interface ToggleIdlePeriodDialogProps extends DefaultDialogProps {
  processingType: IdlePeriodStatusProcessingType
  onConfirm: (type: IdlePeriodStatusProcessingType, values?: PeriodFormInputType) => void
}

const initialFormValues = { start: '', end: '', isActive: false } as PeriodFormInputType
const ToggleIdlePeriodDialog: React.VFC<ToggleIdlePeriodDialogProps> = ({ place, onClose, onConfirm, processingType }) => {
  const { t } = useCustomTranslation()

  const doActivation = useMemo<boolean>(() => processingType === 'activate', [processingType])

  const handleConfirm = useCallback(
    (values: PeriodFormInputType) => {
      onConfirm(processingType, values)
      onClose()
    },
    [onClose, onConfirm, processingType]
  )

  return (
    <Formik initialValues={initialFormValues} onSubmit={handleConfirm}>
      {({ isValid, handleSubmit }) => (
        <Dialog
          title={t('systemSettings.smartFunctions.smartCharge.emsIdlePeriods.dialogs.toggleAll.title')}
          onClose={() => onClose()}
          place={place}
          maxWidth="sm"
          actions={{
            primary: {
              name: t('common.confirm'),
              disabled: !isValid,
              onClick: handleSubmit,
            },
            secondary: [
              {
                name: t('common.cancel'),
              },
            ],
          }}
        >
          {doActivation && <IdlePeriodActivateForm />}
          {!doActivation && <IdlePeriodDeactivateForm />}
        </Dialog>
      )}
    </Formik>
  )
}

export default ToggleIdlePeriodDialog
